module.exports = __webpack_public_path__ + "media/images/icons/icon-greek-licensing-08bdf815896e04d1ec34a881e5e700bf.svg";